module.exports = __webpack_public_path__ + "img/Prong Not Securing.74f70428.png";